"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}
exports.keepValueInRange = function (value, min, max) {
    var val = Math.max(value, min); // min < val
    val = Math.min(val, max); // val < max
    return val;
};
/**
 * Функция находит ближайшее (большее или равное) кратное по отношению к данному значению
 * Знак параметров игнорируется, расчет производится по модулю
 *
 * @param value значение, по отношению к которому ищется ближайшее кратное
 * @param multiplier кратность
 * @param options опции
 *
 * @returns ближайшее кратное, большее или равное числу; null для некорректных параметров
 */
exports.getNearestUpperMultiple = function (value, multiplier, options) {
    /* Не производим нечисловые вычисления */
    if (!Number.isFinite(value) || !Number.isFinite(multiplier)) {
        return null;
    }
    /* Вычисления производим по модулю */
    var valueAbsolute = Math.abs(value);
    var multiplierAbsolute = Math.abs(multiplier);
    /* Не производим расчетов для нулевой кратности */
    if (multiplierAbsolute === 0) {
        /* Не возвращаем 0 в этом случае, так требуется ненулевой результат */
        if (valueAbsolute === 0 && options && options.noZeroMode) {
            return null;
        }
        return valueAbsolute;
    }
    var quotient = Math.floor(valueAbsolute / multiplierAbsolute); // Частное
    var remainder = valueAbsolute % multiplierAbsolute; // Остаток
    if (valueAbsolute === 0 && options && options.noZeroMode) {
        return multiplierAbsolute;
    }
    if (remainder === 0) {
        return valueAbsolute;
    }
    return (quotient + 1) * multiplierAbsolute;
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/number_helpers.ts
// module id = 8
// module chunks = 0